var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProfileDelete = function SvgIconProfileDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16h16V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.29 4.675-.734-1.417C9.476 3.115 9.307 3 9.178 3H6.821c-.129 0-.298.116-.376.257l-.801 1.418m6.067 0H4.234l.748 8.008a.361.361 0 0 0 .36.317h5.262a.36.36 0 0 0 .359-.317l.748-8.008zM3 4.675h10",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
};
export default SvgIconProfileDelete;